export default __webpack_public_path__ + "static/media/fpa60200.a491ae70.png";